/**
 * API Configuration
 * Centralized configuration for all API endpoints
 */

//'https://kiloba-api.deploystest.com/api'
// http://localhost:18000/api
//https://brooklyn-thursday-database-minimal.trycloudflare.com
export const API_CONFIG = {
  BASE_URL: 'https://kiloba-api.deploystest.com/api',
  CLIENT_BASE_URL: 'https://kilobagame.kienlongbank.com',
} as const;

export default API_CONFIG;
